export const BACKEND_BASE_URL = 'https://priority-power-portal.uc.r.appspot.com'
// export const BACKEND_BASE_URL = 'http://localhost:5000'
